module.exports = __webpack_public_path__ + "static/media/chat (1).b622af4d.svg";